export default "__VITE_ASSET__2939a8da__"